import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./main/pages/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'clientes',
    loadChildren: () =>
      import('./main/pages/customers/customers.module').then(
        (m) => m.CustomerModule
      ),
  },
  {
    path: 'planes',
    loadChildren: () =>
      import('./main/pages/plans/plan.module').then((m) => m.PlanModule),
  },
  {
    path: 'whatsapp',
    loadChildren: () =>
      import('./main/pages/whatsapp/whatsapp.module').then(
        (m) => m.WhatsappModule
      ),
  },
  {
    path: 'remitentes',
    loadChildren: () =>
      import('./main/pages/senders/senders.module').then(
        (m) => m.SendersModule
      ),
  },
  {
    path: 'paises',
    loadChildren: () =>
      import('./main/pages/countries/countries.module').then(
        (m) => m.CountriesModule
      ),
  },
  {
    path: 'directorio-telefonico',
    loadChildren: () =>
      import('./main/pages/phonebooks/phonebook.module').then(
        (m) => m.PhonebookModule
      ),
  },
  {
    path: 'seguridad',
    loadChildren: () =>
      import('./main/pages/security/security.module').then(
        (m) => m.SecurityModule
      ),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./main/pages/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'sms',
    loadChildren: () =>
      import('./main/pages/sms/sms.module').then((m) => m.SmsModule),
  },
  {
    path: 'inbox',
    loadChildren: () =>
      import('./main/pages/inbox/inbox.module').then((m) => m.InboxModule),
  },
  {
    path: 'categorias',
    loadChildren: () =>
      import('./main/pages/category/category.module').then(
        (m) => m.CategoryModule
      ),
  },
  {
    path: 'monedas',
    loadChildren: () =>
      import('./main/pages/currency/currency.module').then(
        (m) => m.CurrencyModule
      ),
  },
  {
    path: 'soporte',
    loadChildren: () =>
      import('./main/pages/support/support.module').then(
        (m) => m.SupportModule
      ),
  },
  {
    path: 'campaing-builder',
    loadChildren: () =>
      import('./main/pages/campaing-builder/campaing-builder.module').then(
        (m) => m.CampaingModule
      ),
  },
  {
    path: 'reportes',
    loadChildren: () =>
      import('./main/pages/reports/reports.module').then(
        (m) => m.ReportsModule
      ),
  },
  {
    path: 'facturacion',
    loadChildren: () =>
      import('./main/pages/invoices/invoices.module').then(
        (m) => m.InvoicesModule
      ),
  },
  {
    path: 'smpp',
    loadChildren: () =>
      import('./main/pages/smpp/smpp.module').then((m) => m.SmppModule),
  },
  {
    path: 'bitacora',
    loadChildren: () =>
      import('./main/pages/actions-log/actions-log.module').then(
        (m) => m.ActionsLogModule
      ),
  },
  {
    path: 'autenticacion',
    loadChildren: () =>
      import('./main/pages/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: 'productos',
    loadChildren: () =>
      import('./main/pages/products/products.module').then(
        (m) => m.ProductsModule
      ),
  },
  {
    path: 'perfil',
    loadChildren: () =>
      import('./main/pages/profile/profile.module').then(
        (m) => m.ProfileModule
      ),
  },
  {
    path: 'resumen',
    loadChildren: () =>
      import('./main/pages/summary/summary.module').then(
        (m) => m.SummaryModule
      ),
  },
  {
    path: 'archivos-guardados',
    loadChildren: () =>
      import('./main/pages/file-archive/file-archive.module').then(
        (m) => m.FileArchiveModule
      ),
  },
  {
    path: 'email',
    loadChildren: () =>
      import('./main/pages/email/email.module').then(
        (m) => m.EmailModule
      ),
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/miscellaneous/error',
  },
  /* {
        path: 'authentication/login',
        component: AuthLoginV1Component,
        data: { animation: 'auth' }
    } */
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
